import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EndPointApi } from '@helpers/endpointapi';
import { AlarmGroupSettingEvents } from 'icreate/common/io-event/websocket-message';
import { AlarmGroup, AlarmGroupConsolePayload, OutputConsoleSetting } from 'icreate/common/models/alarm-group';
import { lastValueFrom } from 'rxjs';
import { SocketMiddlewareService } from './socket-middleware.service';

@Injectable({
    providedIn: 'root',
})
export class AlarmGroupConsoleSettingsService {
    private domain: string;
    private headers: any = new HttpHeaders({
        'Content-Type': 'application/json',
    });

    constructor(
        private http: HttpClient,
        private socketService: SocketMiddlewareService
    ) {
        this.domain = EndPointApi.iApiDomain();
    }

    async getAll(vesselId: string): Promise<(AlarmGroup & AlarmGroupConsolePayload)[]> {
        return await lastValueFrom(
            this.http.get<(AlarmGroup & AlarmGroupConsolePayload)[]>(`${this.domain}/api/alarmGroupSetting`, {
                headers: this.headers,
                params: { vesselId },
            })
        );
    }

    async getOutputBySlotId(slotId: string): Promise<(OutputConsoleSetting & { AlarmGroup: AlarmGroup })[]> {
        return await lastValueFrom(
            this.http.get<(OutputConsoleSetting & { AlarmGroup: AlarmGroup })[]>(
                `${this.domain}/api/alarmGroupSetting/ouput-settings`,
                {
                    headers: this.headers,
                    params: { slotId },
                }
            )
        );
    }

    async save(settingsPayload: AlarmGroupConsolePayload) {
        return await lastValueFrom(
            this.http.put(`${this.domain}/api/alarmGroupSetting`, settingsPayload, {
                headers: this.headers,
            })
        );
    }

    alarmSettingUpdated$() {
        return this.socketService.receiveMessageObserver(AlarmGroupSettingEvents.SETTINGS_UPDATED);
    }
}
